import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\AssociationController::index
* @see Http/Controllers/AssociationController.php:33
* @route '/projects/{project}/associations'
*/
export const index = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/projects/{project}/associations',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AssociationController::index
* @see Http/Controllers/AssociationController.php:33
* @route '/projects/{project}/associations'
*/
index.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return index.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AssociationController::index
* @see Http/Controllers/AssociationController.php:33
* @route '/projects/{project}/associations'
*/
index.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AssociationController::index
* @see Http/Controllers/AssociationController.php:33
* @route '/projects/{project}/associations'
*/
index.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\AssociationController::index
* @see Http/Controllers/AssociationController.php:33
* @route '/projects/{project}/associations'
*/
const indexForm = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AssociationController::index
* @see Http/Controllers/AssociationController.php:33
* @route '/projects/{project}/associations'
*/
indexForm.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AssociationController::index
* @see Http/Controllers/AssociationController.php:33
* @route '/projects/{project}/associations'
*/
indexForm.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\AssociationController::store
* @see Http/Controllers/AssociationController.php:91
* @route '/projects/{project}/associations'
*/
export const store = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/projects/{project}/associations',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AssociationController::store
* @see Http/Controllers/AssociationController.php:91
* @route '/projects/{project}/associations'
*/
store.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return store.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AssociationController::store
* @see Http/Controllers/AssociationController.php:91
* @route '/projects/{project}/associations'
*/
store.post = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\AssociationController::store
* @see Http/Controllers/AssociationController.php:91
* @route '/projects/{project}/associations'
*/
const storeForm = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\AssociationController::store
* @see Http/Controllers/AssociationController.php:91
* @route '/projects/{project}/associations'
*/
storeForm.post = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\AssociationController::destroy
* @see Http/Controllers/AssociationController.php:120
* @route '/projects/{project}/associations/{paperFile}'
*/
export const destroy = (args: { project: string | number | { id: string | number }, paperFile: string | number | { id: string | number } } | [project: string | number | { id: string | number }, paperFile: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/projects/{project}/associations/{paperFile}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\AssociationController::destroy
* @see Http/Controllers/AssociationController.php:120
* @route '/projects/{project}/associations/{paperFile}'
*/
destroy.url = (args: { project: string | number | { id: string | number }, paperFile: string | number | { id: string | number } } | [project: string | number | { id: string | number }, paperFile: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            project: args[0],
            paperFile: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
        paperFile: typeof args.paperFile === 'object'
        ? args.paperFile.id
        : args.paperFile,
    }

    return destroy.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace('{paperFile}', parsedArgs.paperFile.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AssociationController::destroy
* @see Http/Controllers/AssociationController.php:120
* @route '/projects/{project}/associations/{paperFile}'
*/
destroy.delete = (args: { project: string | number | { id: string | number }, paperFile: string | number | { id: string | number } } | [project: string | number | { id: string | number }, paperFile: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\AssociationController::destroy
* @see Http/Controllers/AssociationController.php:120
* @route '/projects/{project}/associations/{paperFile}'
*/
const destroyForm = (args: { project: string | number | { id: string | number }, paperFile: string | number | { id: string | number } } | [project: string | number | { id: string | number }, paperFile: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\AssociationController::destroy
* @see Http/Controllers/AssociationController.php:120
* @route '/projects/{project}/associations/{paperFile}'
*/
destroyForm.delete = (args: { project: string | number | { id: string | number }, paperFile: string | number | { id: string | number } } | [project: string | number | { id: string | number }, paperFile: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

/**
* @see \App\Http\Controllers\AssociationController::autoMatch
* @see Http/Controllers/AssociationController.php:197
* @route '/projects/{project}/associations/auto-match'
*/
export const autoMatch = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: autoMatch.url(args, options),
    method: 'post',
})

autoMatch.definition = {
    methods: ["post"],
    url: '/projects/{project}/associations/auto-match',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AssociationController::autoMatch
* @see Http/Controllers/AssociationController.php:197
* @route '/projects/{project}/associations/auto-match'
*/
autoMatch.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return autoMatch.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AssociationController::autoMatch
* @see Http/Controllers/AssociationController.php:197
* @route '/projects/{project}/associations/auto-match'
*/
autoMatch.post = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: autoMatch.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\AssociationController::autoMatch
* @see Http/Controllers/AssociationController.php:197
* @route '/projects/{project}/associations/auto-match'
*/
const autoMatchForm = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: autoMatch.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\AssociationController::autoMatch
* @see Http/Controllers/AssociationController.php:197
* @route '/projects/{project}/associations/auto-match'
*/
autoMatchForm.post = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: autoMatch.url(args, options),
    method: 'post',
})

autoMatch.form = autoMatchForm

/**
* @see \App\Http\Controllers\AssociationController::deduplicate
* @see Http/Controllers/AssociationController.php:138
* @route '/projects/{project}/associations/deduplicate'
*/
export const deduplicate = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: deduplicate.url(args, options),
    method: 'post',
})

deduplicate.definition = {
    methods: ["post"],
    url: '/projects/{project}/associations/deduplicate',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AssociationController::deduplicate
* @see Http/Controllers/AssociationController.php:138
* @route '/projects/{project}/associations/deduplicate'
*/
deduplicate.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return deduplicate.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AssociationController::deduplicate
* @see Http/Controllers/AssociationController.php:138
* @route '/projects/{project}/associations/deduplicate'
*/
deduplicate.post = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: deduplicate.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\AssociationController::deduplicate
* @see Http/Controllers/AssociationController.php:138
* @route '/projects/{project}/associations/deduplicate'
*/
const deduplicateForm = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: deduplicate.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\AssociationController::deduplicate
* @see Http/Controllers/AssociationController.php:138
* @route '/projects/{project}/associations/deduplicate'
*/
deduplicateForm.post = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: deduplicate.url(args, options),
    method: 'post',
})

deduplicate.form = deduplicateForm

const AssociationController = { index, store, destroy, autoMatch, deduplicate }

export default AssociationController